import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

//import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class SharedDataService {

  constructor(private _http: HttpClient) { }
  get apiUrl() {
    //if (environment.production) return this.configService.config.apiUrl;
    return environment.apiUrl;
  }


  GetRecords(path, cond: any, skipCount: number, maxCountResult: number) {
    const params = {
      pageIndex: skipCount.toString(),
      pageSize: maxCountResult.toString()
    };

    if (cond?.['search']) {
      params['search'] = cond['search'];
    }


    return this._http.get(`${this.apiUrl}${path}`, { params });
  }
  actionUrl: any;
  _getBlobExcel(path, search) {

    return this._http.post<Blob>(`${this.apiUrl}${path}`, search, { responseType: 'blob' as 'json', params: new HttpParams().set('fileName', "Terrapay"), observe: 'response' });
  }
  GetRecord(path) {
    return this._http.get(`${this.apiUrl}${path}`);
  }
  DeleteRecord(path) {
    return this._http.delete(`${this.apiUrl}${path}`);
  }
  EditRecord(path, params) {
    return this._http.put(`${this.apiUrl}${path}`, params);
  }
  AddRecord(path, params) {
    return this._http.post(`${this.apiUrl}${path}`, params);
  }

  AddEditRecord(path, params, id) {
    if (id) {
      return this._http.put(`${this.apiUrl}${path}`, params);
    } else {
      return this._http.post(`${this.apiUrl}${path}`, params);
    }

  }

  GetList(path, params) {
    return this._http.post(`${this.apiUrl}${path}`, params);
  }

}
